// Contact events for the measurement pixel. GTM runs inside Shopify's sandboxed custom pixel and can't see
// page clicks, so the theme publishes them with Shopify.analytics.publish; the pixel (tasks/gtm-custom-pixel.js)
// subscribes to the same names and pushes them to dataLayer.
(() => {
  const pub = (name, data) => {
    try { window.Shopify?.analytics?.publish(name, { page: location.pathname, ...data }); } catch (e) { /* tracking must never break the page */ }
  };

  // Clicks: WhatsApp (header CTA, floating button, product and treatment links), phone, email.
  const links = [['a[href*="wa.me"]', 'contact_whatsapp'], ['a[href^="tel:"]', 'contact_phone'], ['a[href^="mailto:"]', 'contact_email']];
  document.addEventListener('click', (e) => {
    for (const [selector, name] of links) {
      const a = e.target.closest?.(selector);
      if (a) return pub(name, { label: (a.getAttribute('aria-label') || a.textContent).trim().slice(0, 60) });
    }
  });

  // Forms post to /contact and Shopify returns to the page with ?contact_posted=true (contact form) or
  // ?customer_posted=true (newsletter and pop-up), without telling us which form it was: both customer
  // forms report success on the same page. So remember the last submitted form and count it once on the return.
  const forms = { 'ng-news': 'newsletter_signup', 'ng-signup-form': 'signup_popup', 'ng-contact-form': 'contact_form' };
  const KEY = 'ng-last-form';
  document.addEventListener('submit', (e) => {
    // Any Shopify contact form counts: the /pages/contact form is a theme block with a generated id.
    const name = forms[e.target.id] || (e.target.querySelector?.('[name=form_type]')?.value === 'contact' ? 'contact_form' : '');
    if (name) try { sessionStorage.setItem(KEY, name); } catch (err) { /* no storage: form events are skipped */ }
  });
  if (/[?&](contact|customer)_posted=true/.test(location.search)) {
    try {
      const name = sessionStorage.getItem(KEY);
      sessionStorage.removeItem(KEY); // a reload of the same URL must not count again
      if (name) pub(name);
    } catch (err) { /* ignore */ }
  }
})();
